<template>

    <CascoAjanlatBase :titleExtra="titleExtra" v-if="tobbSzerzSzamVisible()">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <v-layout row wrap>

              <BnFormField v-if="tobbSzerzSzamVisible()" :attributes="this['generali_casco_tobbszerzkedv_azon']" />

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>
import CascoAjanlatBase from '../../kgfb/KGFBAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';

export default {
    name: 'AjanlatAdatokB2_V0',
    components: {BnFormField, CascoAjanlatBase },
    mixins: [cascoOfferData],
    methods: {
      tobbSzerzSzamVisible() {
        return this.kedvezmenyek.tobbszerz; // TODO::
      },
    },
    data() {
        return {
            generali_casco_tobbszerzkedv_azon: {
            type: 'text',
            label: 'Többszerződés kedvezmény hivatkozási száma',
            visible: true,
            editable: true,
            help: true,
            mezo: 'generali_casco_tobbszerzkedv_azon',
            path: 'tarifaData.generali_casco_tobbszerzkedv_azon',
          },
        };
    },
};
</script>
